import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as chanceApi from '../../lib/api/chance';
import { firstDayofYear, lastDayofYear } from '../../utils/calcDatetime';

const [
  LIST_BASE_CHANCES,
  LIST_BASE_CHANCES_SUCCESS,
  LIST_BASE_CHANCES_FAILURE,
] = createRequestActionTypes('chance/LIST_BASE_CHANCES');

export const listBaseChances = createAction(
  LIST_BASE_CHANCES,
  (searchData) => searchData,
);
const listBaseChancesSaga = createRequestSaga(
  LIST_BASE_CHANCES,
  chanceApi.getBaseChances,
);

const SET_BASE_FITERS = 'chance/SET_BASE_FITERS';
export const setBaseFilters = createAction(
  SET_BASE_FITERS,
  (filters) => filters,
);

const RESET_BASE_FILTERS = 'chance/RESET_BASE_FILTERS';
export const resetBaseFilters = createAction(RESET_BASE_FILTERS);

export function* chanceBasesSaga() {
  yield takeLatest(LIST_BASE_CHANCES, listBaseChancesSaga);
}

const initialState = {
  totals: null,
  chances: null,
  error: null,
  defaultFilters: {
    useYn: 'Y',
    searchGrade: '',
    searchPrjTyp: '',

    // 중요도 필터(전체/H/M/L, 수정안_0312_2) - 기본값은 전체(필터 없음)
    searchPrjImpt: '',
    searchKeyword: 'cstNm',
    searchWords: '',
    // searchStrtDt: firstDayofYear,
    // searchEndDt: lastDayofYear,
    searchStrtDt: '',
    searchEndDt: '',
    searchDpt: '',
    searchUsr: '',

    // 메인화면 재검토(Fable, 2026-10-23) §3 "카드=목록 건수" 규칙 - 홈 위젯 카드에서
    // ?cstStatusNot=/&ordrEstStrtDt=/&ordrEstEndDt=/&cngDtBefore= 로 들어오는 딥링크 필터.
    // 기본값은 빈 문자열(필터 없음) - ChanceListContainer가 마운트 시 URL을 읽어 덮어쓴다.
    searchCstStatusNot: '',
    searchOrdrEstStrtDt: '',
    searchOrdrEstEndDt: '',
    searchCngDtBefore: '',
  },
};



const chanceBases = handleActions(
  {
    [LIST_BASE_CHANCES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      totals: data?.totals,
      chances: data.list.map((chance) => ({
        id: chance.prjUuid,
        prjSeq: chance.prjSeq,
        prjUuid: chance.prjUuid,
        prjNo: chance.prjNo,
        cstNm: chance.cstNm,
        cstStatus: chance.cstStatus,
        cstGrade: chance.cstGrade,
        prjTyp: chance.prjTyp,
        // partnerInc: chance.partnerInc,
        // chargeNm: chance.chargeNm,
        // chargeEml: chance.chargeEml,
        // chargeTel: chance.chargeTel,
        chanceTyp: chance.chanceTyp,
        prjImpt: chance.prjImpt,
        bugetYn: chance.bugetYn,
        // partnerTyp: chance.partnerTyp,
        incTyp: chance.incTyp,
        // solutionTyp: chance.solutionTyp,
        productYn: chance.productYn,
        vendorCmp: chance.vendorCmp,
        vendorCmpNm: chance.vendorCmpNm,
        // vendorEmp: chance.vendorEmp,
        // vendorEmpNm: chance.vendorEmpNm,
        expBenefitRate: chance.expBenefitRate,
        expSales: chance.expSales,
        expBuy: chance.expBuy,
        expDay: chance.expDay,
        // pmUsr: chance.pmUsr,
        // pmNm: chance.pmNm,
        // plUsr: chance.plUsr,
        // plNm: chance.plNm,
        // techUsr: chance.techUsr,
        // techNm: chance.techNm,
        costYn: chance.costYn,
        mtnFreeTor: chance.mtnFreeTor,
        mtnPayTor: chance.mtnPayTor,
        mtnFreeSt: chance.mtnFreeSt,
        mtnFreeEd: chance.mtnFreeEd,
        mtnPaySt: chance.mtnPaySt,
        mtnPayEd: chance.mtnPayEd,
        totalPurchase: chance?.totalPurchase,
        totalSales: chance?.totalSales,
        totalProfit: chance?.totalProfit,
        totalMargin: chance?.totalMargin,
        useYn: chance.useYn,
        crtDptNm: chance.crtDptNm,
        crtNm: chance.crtNm,
        crtGradeNm: chance.crtGradeNm,
        crtDt: chance.crtDt,
        cngNm: chance.cngNm,
        cngDt: chance.cngDt,
      })),
      error: null,
    }),
    [LIST_BASE_CHANCES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [RESET_BASE_FILTERS]: (state) => ({
      ...state,
      defaultFilters: initialState.defaultFilters,
    }),
    [SET_BASE_FITERS]: (state, { payload: filters }) => ({
      ...state,
      defaultFilters: filters,
    }),
  },
  initialState,
);

export default chanceBases;
